/* tslint:disable */
/* eslint-disable */
/**
 * SPD
 * Opis api SPD
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { GetRegisterDto } from './GetRegisterDto';
import {
    GetRegisterDtoFromJSON,
    GetRegisterDtoFromJSONTyped,
    GetRegisterDtoToJSON,
} from './GetRegisterDto';
import type { GetUserDto } from './GetUserDto';
import {
    GetUserDtoFromJSON,
    GetUserDtoFromJSONTyped,
    GetUserDtoToJSON,
} from './GetUserDto';
import type { GetExamDto } from './GetExamDto';
import {
    GetExamDtoFromJSON,
    GetExamDtoFromJSONTyped,
    GetExamDtoToJSON,
} from './GetExamDto';
import type { GetCardDto } from './GetCardDto';
import {
    GetCardDtoFromJSON,
    GetCardDtoFromJSONTyped,
    GetCardDtoToJSON,
} from './GetCardDto';
import type { GetArticleDto } from './GetArticleDto';
import {
    GetArticleDtoFromJSON,
    GetArticleDtoFromJSONTyped,
    GetArticleDtoToJSON,
} from './GetArticleDto';

/**
 * 
 * @export
 * @interface GetJudgmentExtendedDto
 */
export interface GetJudgmentExtendedDto {
    /**
     * 
     * @type {string}
     * @memberof GetJudgmentExtendedDto
     */
    id: string;
    /**
     * 
     * @type {string}
     * @memberof GetJudgmentExtendedDto
     */
    number?: string | null;
    /**
     * 
     * @type {number}
     * @memberof GetJudgmentExtendedDto
     */
    lp?: number | null;
    /**
     * 
     * @type {GetExamDto}
     * @memberof GetJudgmentExtendedDto
     */
    exam?: GetExamDto | null;
    /**
     * 
     * @type {Date}
     * @memberof GetJudgmentExtendedDto
     */
    nextExamDate?: Date | null;
    /**
     * 
     * @type {Date}
     * @memberof GetJudgmentExtendedDto
     */
    judgmentDate?: Date | null;
    /**
     * 
     * @type {GetArticleDto}
     * @memberof GetJudgmentExtendedDto
     */
    article?: GetArticleDto | null;
    /**
     * 
     * @type {GetUserDto}
     * @memberof GetJudgmentExtendedDto
     */
    psychologist?: GetUserDto | null;
    /**
     * 
     * @type {boolean}
     * @memberof GetJudgmentExtendedDto
     */
    pass?: boolean | null;
    /**
     * 
     * @type {string}
     * @memberof GetJudgmentExtendedDto
     */
    occupationalMedicineOneCategory?: string | null;
    /**
     * 
     * @type {string}
     * @memberof GetJudgmentExtendedDto
     */
    occupationalMedicineText?: string | null;
    /**
     * 
     * @type {string}
     * @memberof GetJudgmentExtendedDto
     */
    vehicleRestriction?: string | null;
    /**
     * 
     * @type {string}
     * @memberof GetJudgmentExtendedDto
     */
    personRestriction?: string | null;
    /**
     * 
     * @type {string}
     * @memberof GetJudgmentExtendedDto
     */
    drivingLicense?: string | null;
    /**
     * 
     * @type {string}
     * @memberof GetJudgmentExtendedDto
     */
    roadTransport?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof GetJudgmentExtendedDto
     */
    active?: boolean | null;
    /**
     * 
     * @type {boolean}
     * @memberof GetJudgmentExtendedDto
     */
    withoutSign?: boolean | null;
    /**
     * 
     * @type {GetRegisterDto}
     * @memberof GetJudgmentExtendedDto
     */
    register?: GetRegisterDto | null;
    /**
     * 
     * @type {boolean}
     * @memberof GetJudgmentExtendedDto
     */
    twilightVision?: boolean | null;
    /**
     * 
     * @type {boolean}
     * @memberof GetJudgmentExtendedDto
     */
    glareSensitivity?: boolean | null;
    /**
     * 
     * @type {string}
     * @memberof GetJudgmentExtendedDto
     */
    comment?: string | null;
    /**
     * 
     * @type {GetCardDto}
     * @memberof GetJudgmentExtendedDto
     */
    card?: GetCardDto | null;
    /**
     * 
     * @type {boolean}
     * @memberof GetJudgmentExtendedDto
     */
    art39j?: boolean | null;
    /**
     * 
     * @type {boolean}
     * @memberof GetJudgmentExtendedDto
     */
    contactWithFood?: boolean | null;
    /**
     * 
     * @type {Date}
     * @memberof GetJudgmentExtendedDto
     */
    dateFrom?: Date | null;
    /**
     * 
     * @type {Date}
     * @memberof GetJudgmentExtendedDto
     */
    dateTo?: Date | null;
    /**
     * 
     * @type {boolean}
     * @memberof GetJudgmentExtendedDto
     */
    requiresCorrectiveEyewear?: boolean | null;
    /**
     * 
     * @type {string}
     * @memberof GetJudgmentExtendedDto
     */
    statusP1: GetJudgmentExtendedDtoStatusP1Enum | null;
    /**
     * Status of the judgment cancellation document in P1, if any
     * @type {string}
     * @memberof GetJudgmentExtendedDto
     */
    cancelStatusP1: GetJudgmentExtendedDtoCancelStatusP1Enum | null;
    /**
     * Reason given for the judgment cancellation in P1, if any
     * @type {string}
     * @memberof GetJudgmentExtendedDto
     */
    cancellationReason: string | null;
    /**
     * 
     * @type {string}
     * @memberof GetJudgmentExtendedDto
     */
    emailStatus?: string | null;
    /**
     * 
     * @type {string}
     * @memberof GetJudgmentExtendedDto
     */
    companyName?: string | null;
    /**
     * 
     * @type {string}
     * @memberof GetJudgmentExtendedDto
     */
    signatureStatus?: string | null;
}


/**
 * @export
 */
export const GetJudgmentExtendedDtoStatusP1Enum = {
    ToSign: 'ToSign',
    WaitingForP1: 'WaitingForP1',
    AcceptedInP1: 'AcceptedInP1',
    RejectedInP1: 'RejectedInP1',
    ValidationFailed: 'ValidationFailed'
} as const;
export type GetJudgmentExtendedDtoStatusP1Enum = typeof GetJudgmentExtendedDtoStatusP1Enum[keyof typeof GetJudgmentExtendedDtoStatusP1Enum];

/**
 * @export
 */
export const GetJudgmentExtendedDtoCancelStatusP1Enum = {
    ToSign: 'ToSign',
    WaitingForP1: 'WaitingForP1',
    AcceptedInP1: 'AcceptedInP1',
    RejectedInP1: 'RejectedInP1',
    ValidationFailed: 'ValidationFailed'
} as const;
export type GetJudgmentExtendedDtoCancelStatusP1Enum = typeof GetJudgmentExtendedDtoCancelStatusP1Enum[keyof typeof GetJudgmentExtendedDtoCancelStatusP1Enum];


/**
 * Check if a given object implements the GetJudgmentExtendedDto interface.
 */
export function instanceOfGetJudgmentExtendedDto(value: object): value is GetJudgmentExtendedDto {
    if (!('id' in value) || value['id'] === undefined) return false;
    if (!('statusP1' in value) || value['statusP1'] === undefined) return false;
    if (!('cancelStatusP1' in value) || value['cancelStatusP1'] === undefined) return false;
    if (!('cancellationReason' in value) || value['cancellationReason'] === undefined) return false;
    return true;
}

export function GetJudgmentExtendedDtoFromJSON(json: any): GetJudgmentExtendedDto {
    return GetJudgmentExtendedDtoFromJSONTyped(json, false);
}

export function GetJudgmentExtendedDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): GetJudgmentExtendedDto {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'],
        'number': json['number'] == null ? undefined : json['number'],
        'lp': json['lp'] == null ? undefined : json['lp'],
        'exam': json['exam'] == null ? undefined : GetExamDtoFromJSON(json['exam']),
        'nextExamDate': json['nextExamDate'] == null ? undefined : (new Date(json['nextExamDate'])),
        'judgmentDate': json['judgmentDate'] == null ? undefined : (new Date(json['judgmentDate'])),
        'article': json['article'] == null ? undefined : GetArticleDtoFromJSON(json['article']),
        'psychologist': json['psychologist'] == null ? undefined : GetUserDtoFromJSON(json['psychologist']),
        'pass': json['pass'] == null ? undefined : json['pass'],
        'occupationalMedicineOneCategory': json['occupationalMedicineOneCategory'] == null ? undefined : json['occupationalMedicineOneCategory'],
        'occupationalMedicineText': json['occupationalMedicineText'] == null ? undefined : json['occupationalMedicineText'],
        'vehicleRestriction': json['vehicleRestriction'] == null ? undefined : json['vehicleRestriction'],
        'personRestriction': json['personRestriction'] == null ? undefined : json['personRestriction'],
        'drivingLicense': json['drivingLicense'] == null ? undefined : json['drivingLicense'],
        'roadTransport': json['roadTransport'] == null ? undefined : json['roadTransport'],
        'active': json['active'] == null ? undefined : json['active'],
        'withoutSign': json['withoutSign'] == null ? undefined : json['withoutSign'],
        'register': json['register'] == null ? undefined : GetRegisterDtoFromJSON(json['register']),
        'twilightVision': json['twilightVision'] == null ? undefined : json['twilightVision'],
        'glareSensitivity': json['glareSensitivity'] == null ? undefined : json['glareSensitivity'],
        'comment': json['comment'] == null ? undefined : json['comment'],
        'card': json['card'] == null ? undefined : GetCardDtoFromJSON(json['card']),
        'art39j': json['art39j'] == null ? undefined : json['art39j'],
        'contactWithFood': json['contactWithFood'] == null ? undefined : json['contactWithFood'],
        'dateFrom': json['dateFrom'] == null ? undefined : (new Date(json['dateFrom'])),
        'dateTo': json['dateTo'] == null ? undefined : (new Date(json['dateTo'])),
        'requiresCorrectiveEyewear': json['requiresCorrectiveEyewear'] == null ? undefined : json['requiresCorrectiveEyewear'],
        'statusP1': json['statusP1'],
        'cancelStatusP1': json['cancelStatusP1'],
        'cancellationReason': json['cancellationReason'],
        'emailStatus': json['emailStatus'] == null ? undefined : json['emailStatus'],
        'companyName': json['companyName'] == null ? undefined : json['companyName'],
        'signatureStatus': json['signatureStatus'] == null ? undefined : json['signatureStatus'],
    };
}

export function GetJudgmentExtendedDtoToJSON(value?: GetJudgmentExtendedDto | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'id': value['id'],
        'number': value['number'],
        'lp': value['lp'],
        'exam': GetExamDtoToJSON(value['exam']),
        'nextExamDate': value['nextExamDate'] == null ? undefined : ((value['nextExamDate'] as any).toISOString()),
        'judgmentDate': value['judgmentDate'] == null ? undefined : ((value['judgmentDate'] as any).toISOString()),
        'article': GetArticleDtoToJSON(value['article']),
        'psychologist': GetUserDtoToJSON(value['psychologist']),
        'pass': value['pass'],
        'occupationalMedicineOneCategory': value['occupationalMedicineOneCategory'],
        'occupationalMedicineText': value['occupationalMedicineText'],
        'vehicleRestriction': value['vehicleRestriction'],
        'personRestriction': value['personRestriction'],
        'drivingLicense': value['drivingLicense'],
        'roadTransport': value['roadTransport'],
        'active': value['active'],
        'withoutSign': value['withoutSign'],
        'register': GetRegisterDtoToJSON(value['register']),
        'twilightVision': value['twilightVision'],
        'glareSensitivity': value['glareSensitivity'],
        'comment': value['comment'],
        'card': GetCardDtoToJSON(value['card']),
        'art39j': value['art39j'],
        'contactWithFood': value['contactWithFood'],
        'dateFrom': value['dateFrom'] == null ? undefined : ((value['dateFrom'] as any).toISOString()),
        'dateTo': value['dateTo'] == null ? undefined : ((value['dateTo'] as any).toISOString()),
        'requiresCorrectiveEyewear': value['requiresCorrectiveEyewear'],
        'statusP1': value['statusP1'],
        'cancelStatusP1': value['cancelStatusP1'],
        'cancellationReason': value['cancellationReason'],
        'emailStatus': value['emailStatus'],
        'companyName': value['companyName'],
        'signatureStatus': value['signatureStatus'],
    };
}

